<!-- Skeleton -->
<div *ngIf="content.isSkeleton; else listCardContent"
  class="list-card-skeleton flex items-center gap-4 p-3 bg-white rounded-[14px]">
  <div class="skeleton-img-list flex-shrink-0 w-[120px] h-[76px] rounded-xl"></div>
  <div class="flex-1 flex flex-col gap-2">
    <div class="skeleton-text" style="width:70%"></div>
    <div class="skeleton-text short" style="width:45%"></div>
    <div class="skeleton-text short" style="width:30%"></div>
  </div>
  <div class="flex-shrink-0 flex flex-col gap-2 items-end">
    <div class="skeleton-text short w-14"></div>
    <div class="skeleton-text short w-20"></div>
  </div>
</div>

<!-- List Card -->
<ng-template #listCardContent>

  <!-- ===== MOBILE CARD (solo responsive, oculto en desktop) ===== -->
  <div class="mobile-list-card" (click)="navigateContent()">

    <!-- Imagen -->
    <div class="mobile-list-card__img">
      <img [src]="getCardPictureSrc()" (error)="$any($event.target).src = getFallbackPictureSrc()"
        class="absolute inset-0 w-full h-full object-cover" alt="">
    </div>

    <!-- Contenido -->
    <div class="mobile-list-card__body">

      <!-- Tipo • Skill -->
      <div class="mobile-list-card__meta">
        <span class="mobile-list-card__type">
          {{ 'words.' + (content?.data?.type === 'external_content' ? 'course' : content?.data?.type) | translate }}
        </span>
        <ng-container *ngIf="content?.data?.skills && content?.data?.skills.length > 0">
          <span class="mobile-list-card__meta-sep">•</span>
          <span class="mobile-list-card__skill">{{ content?.data?.skills[0]?.name }}</span>
        </ng-container>
      </div>

      <!-- Título -->
      <h3 class="mobile-list-card__title"
        [innerHTML]="content?.data?.title ? content?.data?.title : content?.title"></h3>

      <!-- Descripción -->
      <p class="mobile-list-card__desc"
        [innerHTML]="content?.data?.description ? content?.data?.description : content?.description"></p>

      <!-- Estado inscripción -->
      <div class="mobile-list-card__status" *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents'">
        <ng-container *ngIf="content?.data?.subscribed; else notSubMobile">
          <i class="icon icon-checkmark-circle mobile-list-card__status-icon mobile-list-card__status-icon--ok"></i>
          <span class="mobile-list-card__status-label mobile-list-card__status-label--ok">{{ 'funnel.adoption.signed-up' | translate }}</span>
        </ng-container>
        <ng-template #notSubMobile>
          <i class="fa-regular fa-circle mobile-list-card__status-icon mobile-list-card__status-icon--none"></i>
          <span class="mobile-list-card__status-label">{{ 'words.not-subscribed' | translate }}</span>
        </ng-template>
      </div>

      <!-- Botón acción -->
      <div class="mobile-list-card__actions" *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents' && origin !== 'savedContent'">
        <ng-container *ngIf="!content.data?.archived && !content.data?.isLocked">
          <!-- Inscrito: porcentaje a la izquierda + botón a la derecha -->
          <div *ngIf="content.data?.subscribed" class="mobile-list-card__action-row">
            <span class="mobile-list-card__progress-label">
              {{ 'words.progress_1' | translate }}: {{ content?.data?.progress || 0 }}%
            </span>
            <button class="mobile-list-card__btn mobile-list-card__btn--primary"
              (click)="handlePlayContentAction(); $event.stopPropagation()">
              {{ ((content.data?.progress || 0) >= 100 ? 'words.resume' : ((content.data?.progress || 0) > 0 ? 'words.continue' : 'words.start')) | translate }}
            </button>
          </div>
          <!-- No inscrito: botón ver detalles -->
          <button *ngIf="!content.data?.subscribed"
            class="mobile-list-card__btn mobile-list-card__btn--secondary"
            (click)="navigateContent(); $event.stopPropagation()">
            {{ 'words.see-details' | translate }}
          </button>
        </ng-container>
      </div>

    </div>
  </div>

  <!-- ===== DESKTOP CARD (oculto en móvil) ===== -->
  <div id="card-course"
    class="group flex items-center bg-white rounded-2xl overflow-hidden   hover:shadow-lg  transition-all cursor-pointer">

    <!-- Miniatura del Curso -->
    <div class="w-[180px] flex-shrink-0 overflow-hidden p-3 relative">
      <div class="relative overflow-hidden rounded-[14px] transition-all duration-700 aspect-[10/7] ">
        <img [src]="getCardPictureSrc()" (error)="$any($event.target).src = getFallbackPictureSrc()"
          class="absolute inset-0 w-full h-full object-cover" alt="">
        <div class="overlay group-hover:opacity-0"></div>
        <div class="absolute inset-0 bg-gradient-to-t from-black/30 via-black/5 to-transparent opacity-70"></div>
        <!--tag type -->
        <span
          class="hidden absolute top-2 left-2 text-xs font-semibold px-2.5 py-0.5 rounded-xl text-white/90 backdrop-blur-sm group-hover:opacity-0 transition-opacity duration-300 bg-black/30">
          {{ 'words.' + (content?.data?.type === 'external_content' ? 'course' : content?.data?.type) | translate }}
        </span>
        <!--tag saved -->
       <button (click)="changeLearnLaterContent(); $event.stopPropagation()"
  class="absolute top-2 left-2 w-8 h-8 rounded-full flex items-center justify-center bg-black/40 opacity-0 hover:shadow-sm group-hover:opacity-100 transition-opacity duration-300 z-[4]">
  
  <i [ngClass]="content.saved ? 'icon icon-bookmark-1' : 'icon icon-bookmark'" 
     class="text-white text-sm">
  </i>
  
</button>
        <div
          class="hidden absolute inset-0 bg-black/10  opacity-0 group-hover:opacity-100 transition-all duration-300 z-[2]">
        </div>
      </div>
    </div>

    <!-- Contenido Principal -->
    <div class="flex-1 px-5 py-3 min-w-0">
      <div class="flex items-center gap-2 mb-1 flex-wrap">
        <span class="rounded-full bg-muted px-2 py-0.5 text-xs  text-gray-500">
          {{ 'words.' + (content?.data?.type === 'external_content' ? 'course' : content?.data?.type) | translate }}
        </span>
        <!-- Skills -->
        <ng-container *ngIf="content?.data?.skills && content?.data?.skills.length > 0">
          <ng-container *ngFor="let skill of content?.data?.skills">
            <span class="text-xs font-normal text-gray-500">{{ skill.name }}</span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents'">
          <span class="text-gray-300 text-xs" *ngIf="content?.data?.skills?.length > 0">·</span>
          <span class="text-xs flex items-center gap-0.5" *ngIf="content?.data?.subscribed">
            <i class="icon icon-checkmark-circle text-green-400 text-[11px]"></i>
            <span class="text-gray-500 font-normal">{{ 'funnel.adoption.signed-up' | translate }}</span>
          </span>
          <span class="text-xs flex items-center gap-0.5" *ngIf="!content?.data?.subscribed">
            <i class="fa-regular fa-circle text-gray-300" style="font-size:0.6rem"></i>
            <span class="text-gray-500 font-normal">{{ 'words.not-subscribed' | translate }}</span>
          </span>
        </ng-container>
      </div>

      <h3 class="text-sm font-semibold text-gray-700 leading-snug line-clamp-1" (click)="navigateContent()"
        [innerHTML]="content?.data?.title ? content?.data?.title : content?.title">
      </h3>

      <p class="text-xs text-gray-500 line-clamp-2 mt-1"
        [innerHTML]="content?.data?.description ? content?.data?.description : content?.description">

      </p>


      <!-- Meta Datos (Tiempo y Rating) -->
      <div class="flex items-center gap-2 mt-2">
        <div class="h-5 w-8 bg-contain bg-center bg-no-repeat opacity-80 flex-shrink-0" [style.background-image]="logo" role="img"
          [attr.aria-label]="content?.data?.title || 'Content logo'">
        </div>

        <span class="flex items-center gap-1 text-xs  text-gray-500" *ngIf="content.data?.duration">
          <svg  class="text-xs font-normal text-gray-500 " xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span
            class="text-xs font-normal text-gray-500 ">{{convertSecondsToHoursMinutes(content.data?.duration)}}</span>
        </span>

        <span class="flex items-center gap-1 text-xs text-gray-500">
          <ng-container *ngIf="!content?.data?.notRated; else notRatedList">
            <i class="fas fa-star text-yellow-400 text-xs"></i>
            <span class="text-xs font-normal text-gray-500">{{ content?.data?.rating | number:'1.0-1' }}</span>
          </ng-container>
          <ng-template #notRatedList>
            <i class="fa-regular fa-star text-gray-300 text-xs"></i>
            <span class="text-xs font-normal text-gray-500">0</span>
          </ng-template>
        </span>


      </div>
    </div>

    <!-- Separador Vertical -->
    <div class="w-px self-stretch my-3 bg-gray-200"></div>

    <!-- Acciones -->
    <div class="shrink-0 px-5 flex flex-col gap-2 justify-center">

      <!-- Barra de progreso -->
     <!-- Barra de progreso (normal) - circular -->
        <div *ngIf="(origin !== 'recomendation' || content?.data?.subscribed) && origin !== 'bannerCreation' && origin !== 'savedContent'"
          [ngClass]="origin === 'recomendation' ? 'hidden group-hover:flex' : 'flex'"
          class="items-center justify-center py-1">
          <div class="relative shrink-0 w-14 h-14">

            <!-- 100%: anillo verde + check -->
            <ng-container *ngIf="(content?.data?.progress || 0) >= 100; else ringProgress">
              <svg class="w-full h-full -rotate-90" viewBox="0 0 56 56">
                <circle cx="28" cy="28" r="23" stroke="#e5e7eb" stroke-width="4" fill="none" />
                <circle cx="28" cy="28" r="23"
                  stroke="#22c55e" stroke-width="4" fill="none"
                  stroke-linecap="round"
                  stroke-dasharray="144.51"
                  stroke-dashoffset="0"
                  class="transition-all duration-300 ease-in-out" />
              </svg>
              <div class="absolute inset-0 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="#22c55e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
            </ng-container>

            <!-- < 100%: anillo con color secundario -->
            <ng-template #ringProgress>
              <svg class="w-full h-full -rotate-90" viewBox="0 0 56 56">
                <circle cx="28" cy="28" r="23" stroke="#e5e7eb" stroke-width="4" fill="none" />
                <circle cx="28" cy="28" r="23"
                  stroke="var(--v2-color-secondary-500)" stroke-width="4" fill="none"
                  stroke-linecap="round"
                  [attr.stroke-dasharray]="144.5"
                  [attr.stroke-dashoffset]="144.5 - ((content?.data?.progress || 0) * 144.5 / 100)"
                  class="transition-all duration-300 ease-in-out" />
              </svg>
              <div class="absolute inset-0 flex items-center justify-center">
                <span class="text-xs font-bold leading-none text-gray-700">
                  {{ content?.data?.progress || 0 }}%
                </span>
              </div>
            </ng-template>

          </div>
        </div>

      <!-- Botones y Bookmark -->
      <div class="flex items-center gap-3">
        <ng-container *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents' && origin !== 'savedContent'">
          <ng-container *ngIf="!content.data?.archived && !content.data?.isLocked">
            <msc-button
              customClasses="px-1 h-7 w-full text-[13px] font-semibold py-2 rounded-full transition-all duration-300 text-white bg-secondary-500"
              icon="icon-download" palette="primary" type="fab" [tooltip]="'words.download' | translate"
              [loading]="loading.bookboon" (click)="subscribeAndDownloadExternalContent(); $event.stopPropagation()"
              *ngIf="content.type !== 'external_video' && (content.type === 'external_content' && content.data?.provider) && content.data?.isDownloadable">
            </msc-button>
            <ng-container *ngIf="content.data.externalContentType !== 'audio' || !content.data?.isDownloadable">
              <msc-button
                customClasses="px-1 h-7 w-full text-[13px] font-semibold py-2 rounded-full transition-all duration-300 text-white bg-secondary-500"
                palette="secondary" (click)="handlePlayContentAction(); $event.stopPropagation()"
                *ngIf="content.data?.subscribed">
                <span class="text-[12px] mx-2">{{ ((content.data?.progress || 0) >= 100 ? 'words.resume' : ((content.data?.progress || 0) > 0 ? 'words.continue' : 'words.start')) | translate }}</span>
              </msc-button>
              <msc-button
                customClasses="rounded-full bg-gray-100 text-gray-600 px-1 h-7 w-full text-[14px] font-semibold py-2 transition-all duration-300"
                palette="secondary" (click)="navigateContent(); $event.stopPropagation()"
                *ngIf="!content.data?.subscribed && !content.data?.isDownloadable">
                <span class="text-[12px] mx-2">{{'words.see-details' | translate}}</span>
              </msc-button>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- Bookmark -->
        <button (click)="changeLearnLaterContent(); $event.stopPropagation()"
          class="hidden w-8 h-8 rounded-full  items-center justify-center">
          <i [ngClass]="content.saved ? 'icon icon-bookmark-1 text-secondary' : 'icon icon-bookmark text-gray-500'" class="text-sm"></i>
        </button>
      </div>

    </div>



  </div>



  <!-- Modals (required by parent class methods) -->
  <msc-card-manager-modal-delete-subscription #modalUnsubscribe></msc-card-manager-modal-delete-subscription>
</ng-template>